import React, { Fragment, useEffect, useState } from "react";
import Breadcrumb from "../../common/breadcrumb";
import { Button, Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { DeleteOccasion, GetOccasion } from "../../../redux/actions/productActions";
import DataTable from "react-data-table-component";
import SearchHeader from "../../common/header_components/searchHeader";
import { toast } from "react-toastify";
import { RESET_ERROR } from "../../../redux/constants/userConstants";
import AddOccasion from "./AddOccasion";
import moment from "moment";

const Occasion = () => {
    const dispatch = useDispatch();
    const { getoccasionlist, occasiondelsuccess, editedoccasion, newoccasion, error } = useSelector(state => state.product);
    const [datas, setDatas] = useState([]);
    const [open, setOpen] = useState(false);
    const [activeData, setActiveData] = useState(null);
    const [title, setTitle] = useState("");
    const [filterText, setFilterText] = useState("");

    const customToast = "delOcc";
    const customCToast = "addOcc";
    const customUToast = "editOcc";

    const Capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

    const handleDelete = (id) => {
        if (window.confirm("Are you sure you wish to delete this occasion?")) {
            dispatch(DeleteOccasion(id));
        }
    };

    const handleEdit = (data) => {
        setTitle("Edit Occasion");
        setActiveData(data);
        setOpen(true);
    };

    const onOpenModal = () => {
        setTitle("Add Occasion");
        setActiveData(null);
        setOpen(true);
    };

    const onCloseModal = () => {
        setOpen(false);
    };

    useEffect(() => {
        dispatch(GetOccasion());
    }, []);

    useEffect(() => {
        if (getoccasionlist) {
            setDatas(getoccasionlist);
        }
    }, [getoccasionlist]);

    useEffect(() => {
        if (occasiondelsuccess) {
            toast.success("Occasion deleted successfully", { toastId: customToast });
            dispatch({ type: RESET_ERROR });
        }
    }, [occasiondelsuccess]);

    useEffect(() => {
        if (newoccasion) {
            toast.success("Occasion created successfully", { toastId: customCToast });
            dispatch({ type: RESET_ERROR });
            setActiveData(null);
            setOpen(false);
            setTitle("");
        }
    }, [newoccasion]);

    useEffect(() => {
        if (editedoccasion) {
            toast.success("Occasion updated successfully", { toastId: customUToast });
            dispatch({ type: RESET_ERROR });
            setActiveData(null);
            setOpen(false);
            setTitle("");
        }
    }, [editedoccasion]);

    useEffect(() => {
        if (error) {
            toast.error(`${error.message}`);
            dispatch({ type: RESET_ERROR });
        }
    }, [error]);

    const columns = [
        {
            name: <b>{Capitalize("S.No")}</b>,
            header: <b>{Capitalize("S.No")}</b>,
            cell: (row, index) => index + 1
        },
        {
            name: <b>{Capitalize("Created Date")}</b>,
            header: <b>{Capitalize("Created Date")}</b>,
            selector: row => moment(row?.created_at).format('DD-MM-YYYY'),
            style: { textAlign: "center" },
        },
        {
            name: <b>{Capitalize("Occasion Name")}</b>,
            header: <b>{Capitalize("Occasion Name")}</b>,
            selector: row => row?.name,
            style: { textAlign: "center" },
        },
        {
            name: <b>Actions</b>,
            id: "actions",
            cell: (row) => (
                <>
                    <span onClick={() => handleDelete(row._id)}>
                        <i
                            className="fa fa-trash"
                            style={{ width: 35, fontSize: 20, padding: 11, color: "#e4566e", cursor: "pointer" }}
                        ></i>
                    </span>
                    <span onClick={() => handleEdit(row)}>
                        <i
                            className="fa fa-pencil"
                            style={{ width: 35, fontSize: 20, padding: 11, color: "rgb(40, 167, 69)", cursor: "pointer" }}
                        ></i>
                    </span>
                </>
            )
        }
    ];

    useEffect(() => {
        const filtered = getoccasionlist?.filter(occ =>
            occ?.name?.toLowerCase().includes(filterText?.toLowerCase())
        );
        setDatas(filtered);
    }, [filterText]);

    const subHeaderComponentMemo = React.useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setFilterText('');
            }
        };

        return (
            <div style={{ display: 'flex', justifyContent: 'flex-end', flex: 1 }}>
                <SearchHeader onFilter={e => setFilterText(e.target.value)} onClear={handleClear} filterText={filterText} />
            </div>
        );
    }, [filterText]);

    return (
        <Fragment>
            <Breadcrumb title="Occasion" parent="Products" />
            <Container fluid="true">
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardHeader>
                                <h5>Occasion</h5>
                            </CardHeader>
                            <CardBody>
                                <div className="btn-popup pull-right">
                                    <Button
                                        type="button"
                                        color="secondary"
                                        onClick={onOpenModal}
                                        data-toggle="modal"
                                        data-original-title="test"
                                        data-target="#exampleModal"
                                    >
                                        Add Occasion
                                    </Button>
                                </div>
                                <div className="clearfix"></div>
                                <div id="basicScenario" className="product-physical">
                                    <DataTable
                                        pagination
                                        columns={columns}
                                        data={datas}
                                        fixedHeader
                                        subHeader
                                        subHeaderComponent={subHeaderComponentMemo}
                                    />
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <AddOccasion
                openModal={open}
                onCloseModal={() => {
                    setActiveData(null);
                    setOpen(false);
                }}
                data={activeData}
                setActiveData={setActiveData}
                title={title}
            />
        </Fragment>
    );
};

export default Occasion;

